import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"file-container"}},[(_vm.fileUrlData)?_c(VBtn,{staticStyle:{"margin-bottom":"20px","background-color":"#009688","color":"white"},attrs:{"loading":_vm.isLoading,"disabled":_vm.isLoading},on:{"click":_vm.fetchFile}},[_c(VIcon,[_vm._v(_vm._s(_vm.mdiDownload))]),_vm._v("DOWNLOAD AUTHORIZATION SLIP ")],1):_vm._e(),(_vm.error)?_c('p',{staticClass:"error--text"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }